import storageService from '@/modules/common/services/storageService';
import Vue from 'vue';

const handleLogout = async () => {
  storageService.remove('businessUid');
  storageService.remove('staffUid');
  storageService.remove('userProfile');

  const customLogoutUrl = Vue.prototype.getLogoutUrl();
  const isMobile = Vue.prototype.$isMobile();
  const isCustomLogoutFFEnabled = Vue.prototype.$hasFeature('enforce_custom_logout');
  const isAuthBridgeIntegration = Vue.prototype.$hasFeature('rollout.integration.authbridge');
  // TODO - CHANGE THE URL BASE ON THE ACCOUNT'S DATA
  // AngularJS - auth.js.coffee:126
  const url = new URL(window.location.origin);
  if (window.pov_config.NODE_ENV === 'development') {
    url.port = '7200';
  }

  // Perform logout in frontage
  await fetch(`${url.origin}/app/logout`, { method: 'POST' });

  if (isMobile && !isAuthBridgeIntegration) {
    if (customLogoutUrl && isCustomLogoutFFEnabled) {
      window.location.replace(customLogoutUrl);
    } else {
      // redirect to frontage
      window.location.replace(`${url.origin}/app/logout`);
    }
  } else {
    // Send to the old login page - vcita.me
    const redirectUrl = `${url.origin}/app/redirect/new?to=/logout${customLogoutUrl ? `&redirect_uri=${encodeURIComponent(customLogoutUrl)}` : ''}`;
    window.location.replace(redirectUrl);
  }
};

export default {
  handleLogout,
};
